import ContributionModelBase from '../_generated/modelBases/contribution-model-base';

export default class ContributionModel extends ContributionModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
